import Typography from '@components/common/typography';
import styles from './styles.module.scss';

const UnfreezeCardModal = () => {
    return (
        <div className={styles.wrapper}>
            <Typography className={styles.title} variant="h4">
                Unfreeze card
            </Typography>
            <Typography variant="body3" className={styles.description}>
                Are you sure you want to unfreeze your card? All in-store, online, and ATM
                transactions will be available again. Any pending or scheduled payments linked to
                this card will proceed as usual.
            </Typography>
        </div>
    );
};

export default UnfreezeCardModal;
